module.exports = __webpack_public_path__ + "static/media/meter1.de9e1d83.svg";